import React, {Component} from 'react'

import Header from '@/component/header/header'
// 引入swiper文件及样式
import Swiper from 'swiper/js/swiper'
import 'swiper/css/swiper.css'
// 引入video文件及样式
import videojs from 'video.js'
import 'video.js/dist/video-js.css'

// 最糊引入样式，如果前面的组件中相同类名的，就会覆盖
import './data-center.less'

const formalUrl = require('../../const').BASE_URL
const testUrl = 'http://10.96.81.176:8080/'
const BASE_URL = process.env.NODE_ENV === 'development' ? testUrl : formalUrl

// const BASE_URL = 'http://10.96.81.176:8080/'  // 测试环境

const headerObj = {
  headerImg: require('./images/资料中心.jpg'),
  title: '资源中心',
  desc: '快速获取滴滴AI最新方案与服务'
}
const solveList = [
  {
    title: '智能汽车白皮书',
    decs: '滴滴智能汽车解决方案，面向车企、车载IoT厂商、B端车辆运营商等提供关注驾驶安全的端云一体化解决方案，实时检测危险驾驶行为，有效赋能驾驶安全场景',
    imgUrl: require('./images/智能汽车白皮书.jpg'),
    paperName: 'smart_car'
  },
  {
    title: '智慧城市白皮书',
    decs: '滴滴智慧城市解决方案，利用机器视觉、物联网、大数据及云计算等先进技术，实现对人、车、事件、场景的全面感知、认知与决策，赋能城市的多维场景',
    imgUrl: require('./images/智慧城市白皮书.jpg'),
    paperName: 'smart_city'
  },
  {
    title: '智能排班白皮书',
    decs: '滴滴智能排班解决方案，采用先进的算法模型，分析历史业务数据、天气信息以及交通等外部因素，对未来业务量进行预测，实现整体效率最大化',
    imgUrl: require('./images/智能排班白皮书.jpg'),
    paperName: 'smart_schedule'
  },
  {
    title: '智能客服白皮书',
    decs: '滴滴智能客服解决方案，基于语音识别、语音合成、自然语言处理、知识图谱等AI技术能力，实现智能语音应答、智能在线对话、智能人工辅助等客户服务功能',
    imgUrl: require('./images/智能客服白皮书.jpg'),
    paperName: 'smart_service'
  }
]
const videoList = [
  {
    title: '滴滴AI开放平台宣传视频',
    decs: '滴滴AI开放平台面向行业，全方位开放AI能力与服务，全面推出五大领域AI技术服务和四大行业解决方案。同时，积极构建与持续拓展AI开放生态，共同助力行业企业转型升级，开启产业智能时代无限未来',
    videoPath: 'promotional_video_1',
    imgUrl: require('./images/视频截图_1.png')
  },
  {
    title: '滴滴AI Labs宣传视频',
    decs: '致力于探索 AI 领域技术难题，重点发力机器学习、计算机视觉、运筹学、统计学等领域的前沿技术研究及应用，积极布局下一代技术，不断提升用户出行效率并且优化出行体验，用技术构建智能出行新生态',
    videoPath: 'promotional_video_2',
    imgUrl: require('./images/视频截图_2.png')
  },
  {
    title: '滴滴出行宣传视频',
    decs: '滴滴出行是全球领先的一站式移动出行平台，服务全球超过5.5亿用户，滴滴坚持技术创新，用科技的力量，不断推动汽车和交通领域的变革，为明天注入无限可能。滴滴一下，美好出行',
    videoPath: 'promotional_video_3',
    imgUrl: require('./images/视频截图_3.png')
  },
  {
    title: '世界移动通信大会(MWC)活动视频',
    decs: '2019年MWC世界移动通信大会上，滴滴AI Labs联合日海智能、NVIDIA，共同推出AI车载边缘计算终端，携手打造关注营运车辆驾驶安全的一体化解决方案，为安全出行保驾护航',
    videoPath: 'promotional_video_4',
    imgUrl: require('./images/视频截图_4.png')
  },

]

let popWrap

export default class DataCenter extends Component {
  state = {
    videoPlay: false,
    videoSrc: 'promotional_video_1'
  }

  componentDidMount() {
    let _this = this
    setTimeout(() => {
      new Swiper('.swiper-container', {
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        loopedSlides: 2,
        preventClicksPropagation: true,
        // 如果需要分页器s
        pagination: {
          el: '.swiper-pagination',
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          progress: function (progress) {
            let modify, translate, scale, zIndex
            for (let i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              var slideProgress = this.slides[i].progress;
              modify = 1;
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
              }
              translate = slideProgress * modify * 330 + 'px';
              scale = 1 - Math.abs(slideProgress) / 10;
              zIndex = 299 - Math.abs(Math.round(10 * slideProgress));
              slide.transform('translateX(' + translate + ') scale(' + scale + ')');
              slide.css('zIndex', zIndex);
              slide.css('opacity', 1);
              if (Math.abs(slideProgress) > 3) {
                slide.css('opacity', 0);
              }
            }
          },
          setTransition: function (transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i)
              slide.transition(transition);
            }
          },
          click: function(event) {
            const id = event.toElement.id
            if (id === 'video-play') {
              _this.setState({
                videoSrc: videoList[this.realIndex].videoPath
              })
              _this.handleVideoPlay()
            }
          }
        }
      })
    }, 300)
    //  初始化视频播放器,直接在这个react的实例上面增加一个video属性
  }

  // 视频播放
  handleVideoPlay = () => {
    return new Promise(resolve => {
      this.setState({
        videoPlay: true,
      })
      resolve()
    }).then(res => {
      popWrap = document.getElementById('pop-warp')
      popWrap.addEventListener('mousewheel', (event) => {
        // 监听滚轮事件，阻止滚轮滚动的默认行为
        event.preventDefault()
      })
      this.video = videojs('my-video', {
        autoplay: true,
        muted: false,
        controls: true,
      })
    })
  }

  videoClose = () => {
    this.setState({
      videoPlay: false
    })
    if (this.video) {
      this.video.dispose()
    }
  }

  // 点击获取pdf
  handlePdf = (name) => {
    let pdfPath = ''
    switch(name) {
      case 'white_paper': pdfPath = '滴滴AI开放平台白皮书.pdf'; break;
      case 'blue_paper': pdfPath = '滴滴AI开放平台蓝皮书.pdf'; break;
      case 'smart_service': pdfPath = '滴滴智能客服解决方案白皮书.pdf'; break;
      case 'smart_car': pdfPath = '滴滴智能汽车解决方案白皮书.pdf'; break;
      case 'smart_city': pdfPath = '滴滴智慧城市解决方案白皮书.pdf'; break;
      case 'smart_schedule': pdfPath = '滴滴智能排班解决方案白皮书.pdf'; break;
    }
    window.open(BASE_URL+'static/pdf/'+pdfPath, '_black')
  }


  componentWillUnmount() {
    if (this.video) {
      this.video.dispose()
    }
  }

  render() {
    const {videoPlay, videoSrc} = this.state
    return (
      <div className="data-center">
        <Header {...headerObj}></Header>
        <div className="file-wrap">
          <div className="file-title">
            滴滴AI开放平台官方文件
          </div>
          <div className="file-two-wrap">
            <div className="filt-list">
              <div className="list-title">滴滴AI开放平台-白皮书</div>
              <span className="list-btn" onClick={() => this.handlePdf('white_paper')}>点击获取</span>
            </div>
            <div className="filt-list filt-list-black">
              <div className="list-title">滴滴AI开放平台-蓝皮书</div>
              <span className="list-btn" onClick={() => this.handlePdf('blue_paper')}>点击获取</span>
            </div>
          </div>
        </div>
        {/*解决方案白皮书*/}
        <div className="solve-warp">
          <div className="solve-inner">
            <div className="solve-title">解决方案白皮书</div>
            <ul className="solve-list">
              {
                solveList.map((item, index) => (
                  <div className="solve-bg" key={index} style={{backgroundImage: `url(${item.imgUrl})`}}>
                    <div className="solve-item">
                      <div className="solve-item-title">{item.title}</div>
                      <div className="solve-desc">
                        <div className="desc-content">{item.decs}</div>
                        <div className="solve-btn" onClick={() => this.handlePdf(item.paperName)}>点击获取</div>
                      </div>
                    </div>
                  </div>
                ))
              }
            </ul>
          </div>
        </div>
        {/* 视频中心*/}
        <div className="video-wrap">
          <div className="video-title">视频中心</div>
          <div className="video-content">
            <div className="swiper-container">
              <div className="swiper-wrapper">
                {
                  videoList.map((item, index) => (
                    <div className="swiper-slide" key={index}
                         style={{width: 854, height: 480, backgroundImage: `url(${item.imgUrl})`}}>
                      <div className="slide-list">
                        <div className="slide-desc-content">
                          <div className="desc-title">{item.title}</div>
                          <div className="desc-content">{item.decs}</div>
                        </div>
                        <div className="video-play" id='video-play'></div>
                      </div>
                    </div>
                  ))
                }
              </div>
              <div className="swiper-button-prev"></div>
              <div className="swiper-button-next"></div>
            </div>
          </div>
          <div className="swiper-pagination"></div>
        </div>
        {/* 弹出框视频*/}
        {
          videoPlay ? (
            <div className='pop-wrap' id='pop-warp'>
              <div className="video-wrap-pop">
                <video className='video-js'
                       data-setup="{}"
                       id="my-video">
                  <source src={BASE_URL+videoSrc}
                          type="video/mp4"/>
                </video>
              </div>
              <div className="video-close" onClick={this.videoClose}>
                <i className="iconfont iconguanbi"></i>
              </div>
            </div>
           ) : null
         }

      </div>
    )
  }
}
